module.exports = __webpack_public_path__ + "static/media/1.db1d6518.png";